import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=c242f0aa"
import script from "./Organizer.vue?vue&type=script&lang=js"
export * from "./Organizer.vue?vue&type=script&lang=js"
import style0 from "./Organizer.vue?vue&type=style&index=0&id=c242f0aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports